// extracted by mini-css-extract-plugin
export var copyableField = "_os-4";
export var customerBadge = "_os-0";
export var customerInfoTitle = "_os-2";
export var details = "_os-1";
export var dropdownContainer = "_os-5";
export var dropdownImage = "_os-6";
export var editAssigneeForm = "_os-a";
export var editButton = "_os-3";
export var email = "_os-7";
export var hidden = "_os-d";
export var input = "_os-8";
export var saveButton = "_os-b";
export var shopifyIcon = "_os-c";
export var suggestionBadge = "_os-e";
export var suggestionText = "_os-f";
export var username = "_os-9";